/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Careers_Pay_Per_YearInputs */



/**
* | output |
* | --- |
* | "{amount} per year" |
*
* @param {Careers_Pay_Per_YearInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const careers_pay_per_year = /** @type {((inputs: Careers_Pay_Per_YearInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Pay_Per_YearInputs, { locale?: "en" | "zh" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ (`每年 ${i?.amount}`)
	return /** @type {LocalizedString} */ (`${i?.amount} per year`)
});